import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { IconModule } from '@hglobal/fin-ui';
import { TranslatePipe } from '@ngx-translate/core';

import { NewVersionCheckerService, ThemeService, ViewportService } from '@zeusm/shared/core/services';

import { PwaSetupDialog } from './shared/common/pwa-setup';

@Component({
  selector: 'zeusm-root',
  imports: [TranslatePipe, RouterOutlet, IconModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit, OnDestroy {
  readonly #themeService = inject(ThemeService);
  readonly #pwaSetupDialog = inject(PwaSetupDialog);
  readonly #viewportService = inject(ViewportService);
  readonly #newVersionCheckerService = inject(NewVersionCheckerService);

  readonly isOldIos = this.#pwaSetupDialog.checkOldIos();
  readonly isLandscape = this.#viewportService.isLandscape;

  constructor() {
    this.#themeService.init();
    void this.#newVersionCheckerService;
  }

  ngOnInit(): void {
    this.#viewportService.applyViewportForPlatform();
    this.#viewportService.applyOrientationLock();
    this.#pwaSetupDialog.init();
  }

  ngOnDestroy(): void {
    this.#viewportService.destroyOrientationLock();
  }
}
